import { useEffect, useState } from 'react';
import { goApi } from '../services';
import { apiRoutes } from '../services/apiRoutes';

const useLiveChannelList = () => {
    const [channels, setChannels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getChannels = async () => {
        setLoading(true);
        try {
            const data = await goApi.get(apiRoutes.LIVE_CHANNELS);
            setChannels(data?.data || []);
        } catch (err: any) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getChannels();
    }, []);

    return { channels, loading, error, refetch: getChannels };
};

export default useLiveChannelList;
